import React from 'react';
import { Table } from 'antd';
import { useQuery } from 'react-query';
import api from '../utils/api';

const Bonus = () => {
    const { data: bonusData, isLoading } = useQuery('bonus', async () => {
        const response = await api.get('/bonus');
        return response.data.data;
    });

    const columns = [
        { title: 'Staff', key: 'staff', render: (_, r) => r.staff ? `${r.staff.firstName} ${r.staff.lastName}` : '-' },
        { title: 'Type', dataIndex: 'type', key: 'type' },
        { title: 'Description', dataIndex: 'description', key: 'description' },
        { title: 'Amount', dataIndex: 'amount', key: 'amount', render: (amount) => `$${amount}` },
    ];

    return (
        <div>
            <h1 style={{ marginBottom: 16 }}>Bonus</h1>
            <Table columns={columns} dataSource={bonusData} rowKey="_id" loading={isLoading} />
        </div>
    );
};

export default Bonus;
